import { ReactNode } from "react";
import { Button } from "../ui/button";
import { useModalNavigation } from "@/hooks/useModalNavigation";

export interface ModalTriggerProps {
  /**
   * The modal route to navigate to
   */
  modalPath: string;
  /**
   * Additional state to pass to the modal
   */
  modalState?: Record<string, any>;
  /**
   * Button content (can be text, icon, or other elements)
   */
  children: ReactNode;
  /**
   * Custom CSS class for the button
   */
  className?: string;
  /**
   * Button variant
   */
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  /**
   * Button size
   */
  size?: "default" | "sm" | "lg" | "icon";
  /**
   * Button title attribute
   */
  title?: string;
  /**
   * Whether button is disabled
   */
  disabled?: boolean;
  /**
   * Replace current history entry instead of pushing new one
   */
  replace?: boolean;
}

export const ModalTrigger = ({
  modalPath,
  modalState = {},
  children,
  className,
  variant = "default",
  size = "default",
  title,
  disabled = false,
  replace = false,
}: ModalTriggerProps) => {
  const { openModal } = useModalNavigation();

  const handleClick = () => {
    openModal(modalPath, {
      state: modalState,
      replace,
    });
  };

  return (
    <Button
      className={className}
      variant={variant}
      size={size}
      onClick={handleClick}
      title={title}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
